export const ENDPOINTS = {
  /**
   * @description Endpoints de USUÁRIOS
   * @param {String} LOGIN - Endpoint para login do usuário no sistema
   * @param {String} ALTERAR_SENHA - Endpoint para alterar senha do usuário administrador
   * @param {String} CADASTRAR_USUARIO - Endpoint para cadastrar usuário no sistema
   * @param {String} LISTAR_USUARIOS - Endpoint para listar usuários do sistema
   * @param {String} DESABILITAR_USUARIO - Endpoint para desabilitar usuário do sistema
   * @param {String} HABILITAR_USUARIO - Endpoint para habilitar usuário do sistema
   * @param {String} ALTERAR_USUARIO - Endpoint para alterar usuário do sistema
   * @param {String} EMAIL_RECUPERAR_SENHA - Endpoint para enviar e-mail de recuperação de senha
   * @param {String} RECUPERAR_SENHA_ADMIN - Endpoint para recuperar senha
   */

  LOGIN: "usuario/login",
  ALTERAR_SENHA:
    "usuario/trocarSenha/" /** @param {String} idusuario - ID do usuário */,
  CADASTRAR_USUARIO: "usuario/cadastro",
  LISTAR_USUARIOS: "usuario/listar",
  DESABILITAR_USUARIO:
    "usuario/desabilitar/" /** @param {String} idusuario - ID do usuário */,
  HABILITAR_USUARIO:
    "/usuario/habilitar/" /** @param {String} idusuario - ID do usuário */,
  ALTERAR_USUARIO:
    "usuario/alterar/" /** @param {String} idusuario - ID do usuário */,
  EMAIL_RECUPERAR_SENHA: "usuario/recuperarSenha",
  RECUPERAR_SENHA_ADMIN: "usuario/trocarSenhaToken",
  OBTER_TOKEN_USUARIO: "usuario/loginAsConsumer",

  /**
   * @description Endpoint de DASHBOARD
   * @param {Object} GET_QUANTIDADE_PEDIDOS - Endpoint para obter informações da quantidade de pedidos
   * @param {Object} GET_QUANTIDADE_PRODUTOS - Endpoint para obter informações da quantidade de produtos
   * @param {Object} GET_QUANTIDADE_CLIENTES - Endpoint para obter informações da quantidade de clientes
   * @param {Object} GET_QUANTIDADE_LOJAS - Endpoint para obter informações da quantidade de lojas
   * @param {String} GET_FATURAMENTO - Endpoint para obter informações do faturamento mensal
   * @param {Array} GET_TOP_PRODUTOS - Endpoint para obter informações dos top produtos vendidos
   * @param {Array} GET_TOP_LOJAS - Endpoint para obter informações do top vendas por loja
   * @param {Array} GET_ULTIMOS_PEDIDOS - Endpoint para obter informações dos ultimos pedidos
   * @param {Array} GET_TOP_CLIENTES - Endpoint para obter informações do top vendas por clientes no mês
   * @param {Array} PRODUTOS_LISTAR_EVENTO - Endpoint para listar os eventos
   * @param {String} RESUMO_EVENTO_IDPRODUTO - Endpoint para resumo
   */

  // GET_DASHBOARD_INFO: "dashboard/info",
  GET_QUANTIDADE_PEDIDOS: "/dashboard/info/qtd_ped",
  GET_QUANTIDADE_PRODUTOS: "/dashboard/info/qtd_prod",
  GET_QUANTIDADE_CLIENTES: "/dashboard/info/qtd_cli",
  GET_QUANTIDADE_LOJAS: "/dashboard/info/qtd_lojas",
  GET_FATURAMENTO: "/dashboard/info/faturamento",
  GET_TOP_PRODUTOS: "/dashboard/info/top_produtos",
  GET_TOP_LOJAS: "/dashboard/info/top_lojas",
  GET_ULTIMOS_PEDIDOS: "/dashboard/info/ultimos_ped",
  GET_TOP_CLIENTES: "/dashboard/info/top_clientes",
  GET_VENDAS_DIARIAS: "/dashboard/getVendasPorDiaDashWE",
  GET_VENDAS_DIARIAS_WE: "https://oktoberfest.eleventickets.com/vendas",
  GET_ACESSOS_WE: "https://oktoberfest.eleventickets.com/acessos",
  PRODUTOS_LISTAR_EVENTO:
    "loja/produto/listar/evento/" /** @param {String} listareventos - evento */,
  RESUMO_EVENTO_IDPRODUTO:
    "loja/produto/listar/evento/resumo/" /** @param {String} idproduto - ID do produto */,

  /**
   * @description Endpoints de AGENTES
   * @param {String} LISTAR_AGENTES - Endpoint para listar agentes do sistema
   * @param {String} CADASTRAR_AGENTE - Endpoint para cadastrar agente no sistema
   * @param {String} ALTERAR_AGENTE - Endpoint para alterar agente no sistema @param {String} idagente - ID do agente
   * @param {String} DESABILITAR_AGENTE - Endpoint para desabilitar agentes no sistema @param {String} idagente - ID do agente
   * @param {String} LOGIN_AGENTES - Endpoint para login do agente no sistema
   * @param {String} ALTERAR_SENHA_AGENTE - Endpoint para alterar agente do sistema @param {String} idagente - ID do agente
   */

  LISTAR_AGENTES: "agente/listar",
  CADASTRAR_AGENTE: "agente/cadastro",
  ALTERAR_AGENTE:
    "agente/alterar/" /** @param {String} idagente - ID do agente */,
  DESABILITAR_AGENTE:
    "agente/desabilitar/" /** @param {String} idagente - ID do agente */,
  LOGIN_AGENTES: "agente/login",
  ALTERAR_SENHA_AGENTE:
    "agente/trocarSenha/" /** @param {String} idagente - ID do agente */,

  /**
   * @description Endpoints de PONTOS DE VENDA
   * @param {String} GET_POINTS_OF_SALE - Endpoint para listar pontos de venda do sistema
   * @param {String} REGISTER_POINTS_OF_SALE - Endpoint para cadastrar pontos de venda no sistema
   * @param {String} UPDATE_POINTS_OF_SALE - Endpoint para alterar pontos de venda no sistema @param {String} idponto_venda - ID do PDV
   * @param {String} DISABLE_POINTS_OF_SALE - Endpoint para desabilitar pontos de venda no sistema @param {String} idponto_venda - ID do PDV
   * @param {String} LOGIN_POINTS_OF_SALE - Endpoint para login do PDV no sistema
   * @param {String} UPDATE_POINTS_OF_SALE_PASSWORD - Endpoint para alterar PDV do sistema @param {String} idponto_venda - ID do PDV
   * @param {String} GET_POINT_OF_SALE_STATUS - Endpoint para listar status do PDV no sistema @param {String} tiporetorno - (array | objeto)
   * @param {String} CHANGE_SUPERVISOR_PASSWORD - Endpoint para alterar senha do supervisor do PDV no sistema @param {String} idponto_venda - ID do PDV
   */

  GET_POINTS_OF_SALE: "ponto_venda/listar",
  REGISTER_POINTS_OF_SALE: "ponto_venda/cadastro",
  UPDATE_POINTS_OF_SALE:
    "ponto_venda/alterar/" /** @param {String} idponto_venda - ID do PDV */,
  DISABLE_POINTS_OF_SALE:
    "ponto_venda/desabilitar/" /** @param {String} idponto_venda - ID do PDV */,
  LOGIN_POINTS_OF_SALE: "ponto_venda/login",
  UPDATE_POINTS_OF_SALE_PASSWORD:
    "ponto_venda/trocarSenha/" /** @param {String} idponto_venda - ID do PDV */,
  UPLOAD_DOCUMENT_POINT_OF_SALE: "ponto_venda/documento/upload",
  GET_POINT_OF_SALE_STATUS:
    "ponto_venda/getStatus/" /** @param {String} tiporetorno - (array | objeto) */,
  CHANGE_SUPERVISOR_PASSWORD:
    "/ponto_venda/trocarSenhaSupervisor/" /** @param {String} idponto_venda - ID do PDV */,

  /**
   * @description Endpoints de TIPO DE PONTOS DE VENDA
   * @param {String} LISTAR_TIPO_PDV - Endpoint para listar tipos de pontos de venda do sistema
   * @param {String} CADASTRAR_TIPO_PDV - Endpoint para cadastrar tipos de pontos de venda no sistema
   * @param {String} ALTERAR_TIPO_PDV - Endpoint para alterar tipos de pontos de venda no sistema @param {String} idtipo_pdv - ID do tipo de PDV
   * @param {String} DELETAR_TIPO_PDV - Endpoint para deletar tipos de pontos de venda no sistema @param {String} idtipo_pdv - ID do tipo de PDV
   */

  LISTAR_TIPO_PDV: "tipo_pdv/listar",
  CADASTRAR_TIPO_PDV: "tipo_pdv/cadastro",
  ALTERAR_TIPO_PDV:
    "tipo_pdv/alterar/" /** @param {String} idtipo_pdv - ID do tipo de PDV */,
  DELETAR_TIPO_PDV:
    "tipo_pdv/deletar/" /** @param {String} idtipo_pdv - ID do tipo de PDV */,

  /**
   * @description Endpoints de PERFIS DE USUARIO
   * @param {String} LISTAR_PERFIS_PESSOAS - Endpoint para listar perfis de usuário do sistema
   * @param {String} CADASTRAR_PERFIL_PESSOAS - Endpoint para cadastrar perfis de usuário no sistema
   * @param {String} ALTERAR_PERFIL_PESSOAS - Endpoint para alterar perfis de usuário no sistema @param {String} idperfil - ID do perfil
   * @param {String} DELETAR_PERFIL_PESSOAS - Endpoint para deletar perfis de usuário no sistema @param {String} idperfil - ID do perfil
   * @param {String} LISTAR_MODULOS_PESSOAS - Endpoint para listar permissões de usuário do sistema @param {String} tiporetorno - (array | objeto)
   */

  LISTAR_PERFIS_PESSOAS: "usuario/perfil/listar",
  CADASTRAR_PERFIL_PESSOAS: "usuario/perfil/cadastro",
  ALTERAR_PERFIL_PESSOAS:
    "usuario/perfil/alterar/" /** @param {String} idperfil - ID do perfil */,
  DELETAR_PERFIL_PESSOAS:
    "usuario/perfil/deletar/" /** @param {String} idperfil - ID do perfil */,
  LISTAR_MODULOS_PESSOAS:
    "usuario/perfil/getModulos" /** @param {String} tiporetorno - (array | objeto) */,

  /**
   * @description Endpoints de LOJAS
   * @param {String} LISTAR_LOJAS - Endpoint para listar lojas do sistema
   * @param {String} CADASTRAR_LOJA - Endpoint para cadastrar lojas no sistema
   * @param {String} ALTERAR_LOJA - Endpoint para alterar lojas no sistema @param {String} idloja - ID da loja
   * @param {String} ALTERAR_STATUS_LOJA - Endpoint para alterar status da loja no sistema @param {String} idloja - ID da loja @param {String} status - Status da loja
   * @param {String} UPLOAD_BANNER_LOJA - Endpoint para upload de banner da loja no sistema
   * @param {String} UPLOAD_DOC_LOJA - Endpoint para upload de documentos da loja no sistema
   * @param {String} LISTAR_TIPOS_TAXAS - Endpoint para listar tipo de taxa da loja no sistema
   * @param {String} HABILITAR_USUARIO_LOJA - Endpoint para listar tipo de taxa da loja no sistema
   */

  LISTAR_LOJAS: "loja/listar",
  CADASTRAR_LOJA: "loja/cadastro",
  ALTERAR_LOJA: "loja/alterar/" /** @param {String} idloja - ID da loja */,
  ALTERAR_STATUS_LOJA:
    "/loja/altera/" /** @param {String} idloja - ID da loja */ /** @param {String} status - Status da loja */,
  REMOVER_LOJA: "/loja/deletar/",
  UPLOAD_BANNER_LOJA: "loja/tema/banner/upload",
  UPLOAD_DOC_LOJA: "loja/documento/upload",
  LISTAR_TIPOS_TAXAS: "/loja/getTiposTaxas/",
  HABILITAR_USUARIO_LOJA:
    "/loja/usuario/habilitar/" /**@param {String} idloja - ID da loja */,

  /**
   * @description Endpoints de FORMAS DE PAGAMENTO/LOJA
   * @param {String} LISTAR_FORMAS_PAGAMENTO - Endpoint para listar formas de pagamento
   * @param {String} LISTAR_REGRAS_PAGAMENTO_FIRST - Endpoint para regras de pagamento
   * @param {String} CADASTRAR_FORMA_PAGAMENTO: Endpoint para cadastrar uma forma de pagamento
   * @param {String} ALTERAR_FORMA_PAGAMENTO: Endpoint para editar uma forma de pagamento
   * @param {String} LISTAR_REGRAS_PAGAMENTO_SECOND - Endpoint para regras de pagamento
   * @param {String} LISTAR_FORMAS_ACEITAS_FIRST - Endpoint para regras de pagamento
   * @param {String} LISTAR_FORMAS_ACEITAS_SECOND - Endpoint para regras de pagamento
   * @param {String} LISTAR_BANDEIRAS_ACEITAS: Endpoint para listar bandeiras aceitas
   * @param {String} LISTAR_ADQUIRENTES_FIRST: Endpoint para listar adquirentes
   * @param {String} LISTAR_ADQUIRENTES_SECOND: Endpoint para listar adquirentes
   * @param {String} LISTAR_ANALISE_RISCO_FIRST: Endpoint para listar analise de risco
   * @param {String} LISTAR_ANALISE_RISCO_SECOND: Endpoint para listar analise de risco
   * @param {String} CADASTRAR_REGRA_PAGAMENTO_FIRST: Endpoint para cadastrar regra de pagamento
   * @param {String} CADASTRAR_REGRA_PAGAMENTO_SECOND: Endpoint para cadastrar regra de pagamento
   * @param {String} ALTERAR_REGRA_PAGAMENTO_FIRST: Endpoint para alterar regra de pagamento
   * @param {String} ALTERAR_REGRA_PAGAMENTO_SECOND: Endpoint para alterar regra de pagamento
   */

  LISTAR_FORMAS_PAGAMENTO: "loja/pagamento/" /** ID loja */,
  LISTAR_REGRAS_PAGAMENTO_FIRST: "loja/pagamento/" /** - ID loja */,
  LISTAR_REGRAS_PAGAMENTO_SECOND: "/regras" /** - ID loja */,
  LISTAR_FORMAS_ACEITAS_FIRST: "loja/pagamento/" /** - ID loja */,
  LISTAR_FORMAS_ACEITAS_SECOND: "/aceitas" /** - ID loja */,
  LISTAR_BANDEIRAS_ACEITAS: "loja/pagamento/bandeiras/aceitas",
  CADASTRAR_FORMA_PAGAMENTO: "loja/pagamento/" /** ID loja */,
  ALTERAR_FORMA_PAGAMENTO: "loja/pagamento/" /** ID loja */,
  LISTAR_ADQUIRENTES_FIRST: "loja/pagamento/" /** ID loja */,
  LISTAR_ADQUIRENTES_SECOND: "/adquirentes" /** ID loja */,
  LISTAR_ANALISE_RISCO_FIRST: "loja/pagamento/",
  LISTAR_ANALISE_RISCO_SECOND: "/analise/risco",
  CADASTRAR_REGRA_PAGAMENTO_FIRST: "loja/pagamento/",
  CADASTRAR_REGRA_PAGAMENTO_SECOND: "/regra",
  ALTERAR_REGRA_PAGAMENTO_FIRST: "loja/pagamento/",
  ALTERAR_REGRA_PAGAMENTO_SECOND: "/regra/", // @param {String} idregra - ID da regra

  /**
   * @description Endpoints de CONSUMIDOR/LOJA
   * @param {String} LISTAR_CONSUMIDOR - Endpoint para listar consumidores do sistema
   * @param {String} CADASTRAR_CONSUMIDOR - Endpoint para cadastrar consumidores no sistema
   * @param {String} ALTERAR_CONSUMIDOR - Endpoint para alterar consumidores no sistema @param {String} idconsumidor - ID do consumidor
   * @param {String} DESABILITAR_CONSUMIDOR - Endpoint para deletar consumidores no sistema @param {String} idconsumidor - ID do consumidor
   * @param {String} LOGIN_CONSUMIDOR - Endpoint para upload de foto do consumidor no sistema
   * @param {String} ALTERAR_SENHA_CONSUMIDOR - Endpoint para upload de foto do consumidor no sistema @param {String} idconsumidor - ID do consumidor
   */

  LISTAR_CONSUMIDOR: "consumidor/listar",
  CADASTRAR_CONSUMIDOR: "consumidor/cadastro",
  ALTERAR_CONSUMIDOR:
    "consumidor/alterar/" /** @param {String} idconsumidor - ID do consumidor */,
  DESABILITAR_CONSUMIDOR:
    "consumidor/desabilitar/" /** @param {String} idconsumidor - ID do consumidor */,
  LOGIN_CONSUMIDOR: "consumidor/login",
  ALTERAR_SENHA_CONSUMIDOR:
    "consumidor/trocarSenha/" /** @param {String} idconsumidor - ID do consumidor */,
  IMPRIMIR_INGRESSO: "loja/pedido_item/getIngresso",

  /**
   * @description Endpoints de USUARIOS/LOJA
   * @param {String} LISTAR_USUARIO_LOJA - Endpoint para listar usuários da loja
   * @param {String} CADASTRAR_USUARIO_LOJA - Endpoint para cadastrar usuários na loja
   * @param {String} ALTERAR_USUARIO_LOJA - Endpoint para alterar usuários da loja @param {String} idusuario - ID do usuário
   * @param {String} DESABILITAR_USUARIO_LOJA - Endpoint para deletar usuários da loja @param {String} idusuario - ID do usuário
   * @param {String} LOGIN_USUARIO_LOJA - Endpoint para login de usuários da loja
   * @param {String} ALTERAR_SENHA_USUARIO_LOJA - Endpoint para alterar senha de usuários da loja @param {String} idusuario - ID do usuário
   * @param {String} LISTAR_PEDIDO_USUARIO_LOJA - Endpoint para listar pedidos do usuário da loja
   * @param {String} LISTAR_PEDIDO_ITEM_USUARIO_LOJA - Endpoint para listar itens do pedido do usuário da loja
   * @param {String} SEND_INFO_EMAIL - Endpoint que envia os dados de login do app validador para o email do usuário da loja
   * @param {String} SEND_INFO_EMAIL_NO_PASSWORD - Endpoint que envia os dados de login do app validador para o email do usuário da loja sem a senha
   * @param {String} GET_TERMOS - Endpoint que chama os termos de aceite para usuário lojista
   * @param {String} ACEITE_TERMOS - Endpoint para aceite de termos do usuario lojista
   * @param {String} EMAIL_RECUPERAR_SENHA_LOJISTA - Endpoint que envia email de recuperar senha do usuario lojista
   */

  LISTAR_USUARIO_LOJA: "loja/usuario/listar",
  CADASTRAR_USUARIO_LOJA: "loja/usuario/cadastro",
  ALTERAR_USUARIO_LOJA:
    "loja/usuario/alterar/" /** @param {String} idusuario - ID do usuário */,
  DESABILITAR_USUARIO_LOJA:
    "loja/usuario/desabilitar/" /** @param {String} idusuario - ID do usuário */,
  LOGIN_USUARIO_LOJA: "loja/usuario/login",
  ALTERAR_SENHA_USUARIO_LOJA:
    "loja/usuario/trocarSenha/" /** @param {String} idusuario - ID do usuário */,
  LISTAR_PEDIDO_USUARIO_LOJA: "loja/pedido/listar",
  LISTAR_PEDIDO_ITEM_USUARIO_LOJA: "loja/pedido_item/listar",
  SEND_INFO_EMAIL: "app_validador/enviaLogin",
  SEND_INFO_EMAIL_NO_PASSWORD: "loja/usuario/enviaLogin",
  GET_TERMOS: "loja/usuario/getTermo",
  ACEITE_TERMOS: "loja/usuario/aceiteTermo",
  EMAIL_RECUPERAR_SENHA_LOJISTA: "loja/usuario/recuperarSenha",
  RECUPERAR_SENHA_LOJISTA: "loja/usuario/trocarSenhaToken",

  /**
   * @description Endpoints de PEDIDOS/LOJA
   * @param {String} LISTAR_LOJA_PEDIDO - Endpoint para listar pedidos da loja
   * @param {String} CADASTRAR_LOJA_PEDIDO - Endpoint para cadastrar pedidos na loja
   * @param {String} CADASTRAR_PEDIDO_ITEM - Endpoint para cadastrar itens no pedido na loja @param {String} idpedido - ID do pedido
   * @param {String} REMOVER_PEDIDO - Endpoint para deletar pedidos da loja @param {String} idpedido - ID do pedido
   */

  LISTAR_LOJA_PEDIDO: "loja/pedido/consumidor/listar",
  CADASTRAR_LOJA_PEDIDO: "loja/pedido/cadastro",
  CADASTRAR_PEDIDO_ITEM:
    "loja/pedido_item/cadastro/" /** @param {String} idpedido - ID do pedido */,
  REMOVER_PEDIDO:
    "loja/pedido/remover/" /** @param {String} idpedido - ID do pedido */,

  /**
   * @description Endpoints de SEGMENTOS/LOJA
   * @param {String} LISTAR_SEGMENTOS - Endpoint para listar segmentos da loja
   * @param {String} CADASTRAR_SEGMENTO - Endpoint para cadastrar segmentos na loja
   * @param {String} ALTERAR_SEGMENTO - Endpoint para alterar segmentos da loja @param {String} idsegmento - ID do segmento
   * @param {String} DELETAR_SEGMENTO - Endpoint para deletar segmentos da loja @param {String} idsegmento - ID do segmento
   */

  LISTAR_SEGMENTOS: "loja/segmento/listar",
  CADASTRAR_SEGMENTO: "loja/segmento/cadastro",
  ALTERAR_SEGMENTO:
    "loja/segmento/alterar/" /** @param {String} idsegmento - ID do segmento */,
  DELETAR_SEGMENTO:
    "loja/segmento/deletar/" /** @param {String} idsegmento - ID do segmento */,

  /**
   * @description Endpoints de PERFIS DE USUÁRIOS/LOJA
   * @param {String} LISTAR_PERFIS_LOJA - Endpoint para listar perfis de usuários da loja
   * @param {String} CADASTRAR_PERFIL_LOJA - Endpoint para cadastrar perfis de usuários na loja
   * @param {String} ALTERAR_PERFIL_LOJA - Endpoint para alterar perfis de usuários da loja @param {String} idperfil - ID do perfil
   * @param {String} DELETAR_PERFIL_LOJA - Endpoint para deletar perfis de usuários da loja @param {String} idperfil - ID do perfil
   * @param {String} LISTAR_MODULOS_LOJA - Endpoint para listar modulos da loja
   */

  LISTAR_PERFIS_LOJA: "loja/perfil/listar",
  CADASTRAR_PERFIL_LOJA: "loja/perfil/cadastro",
  ALTERAR_PERFIL_LOJA:
    "loja/perfil/alterar/" /** @param {String} idperfil - ID do perfil */,
  DELETAR_PERFIL_LOJA:
    "perfil/deletar/" /** @param {String} idperfil - ID do perfil */,
  LISTAR_MODULOS_LOJA: "loja/perfil/getModulos",

  /**
   * @description Endpoints de uso geral da loja
   * @param {String} LOJA_SEQUENCIADOR - Endpoint para gerar sequenciador da loja
   * @param {String} CANAIS_DE_VENDA - Endpoint para listar canais de venda da loja @param {String} tiporetorno - (array | objeto)
   * @param {String} FORMAS_DE_PAGAMENTO - Endpoint para listar formas de pagamento da loja @param {String} tiporetorno - (array | objeto)
   * @param {String} LISTAR_FORMA_PAGAMENTO - Endpoint para listar formas de pagamento cadastradas
   * @param {String} LISTAR_FORMA_PAG_LOJA - Endpoint para listar formas de pagamento cadastradas
   */

  LOJA_SEQUENCIADOR: "loja/",
  CANAIS_DE_VENDA:
    "loja/getCanaisVenda" /** @param {String} tiporetorno - (array | objeto) */,
  FORMAS_DE_PAGAMENTO:
    "forma_pagamento/getModosPagamento/" /** @param {String} tiporetorno - (array | objeto) */,
  LISTAR_FORMA_PAGAMENTO: "forma_pagamento/listar",
  LISTAR_FORMA_PAG_LOJA:
    "forma_pagamento/loja/" /**@param {String} sequenciador */,

  /**
   * @description Endpoints de PRODUTOS/LOJA
   * @param {String} LISTAR_PRODUTO - Endpoint para listar produtos da loja
   * @param {String} LISTAR_CANAIS_DE_VENDA_PRODUTO - Endpoint para listar canais de venda produtos da loja
   * @param {String} GET_PRODUTO_BY_ID - Endpoint para buscar produto pelo id @param {String} idproduto - ID do produto
   * @param {Boolean} TROCAR_TAXA - Endpoint que troca a taxa web imply @param {String} idproduto
   * @param {String} CADASTRAR_PRODUTO - Endpoint para cadastrar produtos na loja
   * @param {String} ALTERAR_PRODUTO -  Endpoint para alterar produtos da loja @param {String} idproduto - ID do produto
   * @param {String} DELETAR_PRODUTO - Endpoint para deletar produtos da loja @param {String} idproduto - ID do produto
   * @param {String} LISTAR_TIPOS_PRODUTOS - Endpoint para listar tipos de produtos da loja @param {String} tiporetorno - (array | objeto)
   * @param {String} LISTAR_STATUS_PRODUTOS - Endpoint para listar status de produtos da loja @param {String} tiporetorno - (array | objeto)
   * @param {String} LISTAR_CATEGORIAS_PRODUTOS - Endpoint para listar categorias de produtos da loja
   * @param {String} LISTAR_VARIACOES - Endpoint para listar variações
   * @param {String} LISTAR_TIPO_VARIACOES - Endpoint para listar tipo de variações de produtos da loja @param {String} tiporetorno - (array | objeto)
   * @param {String} UPLOAD_IMAGEM_PRODUTO - Endpoint para upload de imagens de produtos da loja
   * @param {String} UPLOAD_IMAGEM_DESCRICAO_PRODUTO - Endpoint para upload de imagens de descrição de produtos da loja
   * @param {String} ORDENAR_PRODUTO - Endpoint para ordenar produtos da loja/marketplace
   */

  LISTAR_PRODUTO: "loja/produto/listar",
  LISTAR_CANAIS_DE_VENDA_PRODUTO: "loja/produto/getCanaisVenda",
  GET_PRODUTO_BY_ID:
    "loja/produto/" /** @param {String} idproduto - ID do produto */,
  TROCAR_TAXA: "produto/" /** @param {String} idproduto - ID do produto */,
  TAXA_TROCAR: "/trocartaxa" /** @param {String} idproduto - ID do produto */,
  CADASTRAR_PRODUTO: "loja/produto/cadastro",
  ALTERAR_PRODUTO:
    "loja/produto/alterar/" /** @param {String} idproduto - ID do produto */,
  DELETAR_PRODUTO:
    "produto/deletar/" /** @param {String} idproduto - ID do produto */,
  LISTAR_TIPOS_PRODUTOS:
    "loja/produto/getTipos/pt/" /** @param {String} tiporetorno - (array | objeto) */,
  LISTAR_STATUS_PRODUTOS:
    "loja/produto/getStatus/" /** @param {String} tiporetorno - (array | objeto) */,
  LISTAR_CATEGORIAS_PRODUTOS: "loja/produto/categoria/listar",
  LISTAR_VARIACOES: "loja/produto/variacao/listar",
  LISTAR_TIPO_VARIACOES:
    "loja/produto/variacao/getTipos/" /** @param {String} tiporetorno - (array | objeto) */,
  UPLOAD_IMAGEM_PRODUTO: "loja/produto/imagem/upload",
  UPLOAD_IMAGEM_DESCRICAO_PRODUTO: "loja/produto/media/upload",
  ORDENAR_PRODUTO: "loja/produto/reordenarVenda",

  /**
   * @description Endpoints de cupons de Produtos/LOJA
   * @param {String} LISTAR_CUPOM - Endpoint para listar cupons de produtos da loja
   * @param {String} CADASTRAR_CUPOM - Endpoint para cadastrar cupons de produtos na loja
   * @param {String} ALTERAR_CUPOM - Endpoint para alterar cupons de produtos da loja @param {String} idcategoria - ID da categoria
   * @param {String} DELETAR_CUPOM - Endpoint para deletar cupons de produtos da loja @param {String} idcategoria - ID da categoria
   * @param {String} GET_CUPOM - Endpoint para deletar cupons de produtos da loja @param {String} idcategoria - ID da categoria
   * @param {String} RELATORIO_CUPOM - Endpoint para relatório cupons da loja
   */
  LISTAR_CUPOM: "loja/cupom/listar",
  CADASTRAR_CUPOM: "loja/cupom/cadastro",
  ALTERAR_CUPOM: "loja/cupom/alterar",
  DELETAR_CUPOM:
    "loja/cupom/deletar/" /**@param {String} idcupom - ID do cupom */,
  GET_CUPOM: "loja/cupom/id/" /**@param {String} idcupom - ID do cupom */,
  RELATORIO_CUPOM: "relatorio/cupom/loja",

  /**
   * @description Endpoints de Categorias de Produtos/LOJA
   * @param {String} LISTAR_CATEGORIAS - Endpoint para listar categorias de produtos da loja
   * @param {String} CADASTRAR_CATEGORIA - Endpoint para cadastrar categorias de produtos na loja
   * @param {String} ALTERAR_CATEGORIA - Endpoint para alterar categorias de produtos da loja @param {String} idcategoria - ID da categoria
   * @param {String} DELETAR_CATEGORIA - Endpoint para deletar categorias de produtos da loja @param {String} idcategoria - ID da categoria
   */

  LISTAR_CATEGORIAS: "loja/produto/categoria/listar",
  CADASTRAR_CATEGORIA: "loja/produto/categoria/cadastro",
  ALTERAR_CATEGORIA:
    "loja/produto/categoria/alterar/" /** @param {String} idcategoria - ID da categoria */,
  DELETAR_CATEGORIA:
    "loja/produto/categoria/deletar/" /** @param {String} idcategoria - ID da categoria */,

  /**
   * @description Endpoints de VENDAS
   * @param {String} LISTAR_VENDAS - Endpoint para listar vendas da loja
   * @param {String} LISTAR_ITENS_PEDIDO - Endpoint para listar itens do pedido @param {String} idpedido - ID do pedido @param {String} sequenciador - Sequenciador da loja
   * @param {String} LISTAR_ITENS_PEDIDO_MKT - Endpoint para listar itens do pedido marketplace @param {String} idpedido_marketplace - ID do pedido marketplace @param {String} ano_mes - Ano mes da loja
   * @param {String} LISTAR_STATUS_PEDIDO - Endpoint para listar itens do pedido @param {String} idpedido - ID do pedido @param {String} sequenciador - Sequenciador da loja
   * @param {String} CANCELAR_PEDIDO - Endpoint para cancelar pedido @param {String} idpedido - ID do pedido
   * @param {String} CANCELAR_PEDIDO_MKTPLACE - Endpoint para cancelar pedido do marketplace @param {String} idpedido - ID do pedido marketplace
   * @param {String} VALIDATE_TICKET - Endpoint para validar ingresso
   */

  LISTAR_VENDAS: "vendas",
  LISTAR_ITENS_PEDIDO:
    "vendas/itens/" /** @param {String} idpedido - ID do pedido @param {String} sequenciador - Sequenciador da loja */,
  LISTAR_ITENS_PEDIDO_MKT:
    "vendas/marketplace/itens/" /** @param {String} idpedido_marketplace - ID do pedido marketplace @param {String} ano_mes - Ano mes da loja */,
  LISTAR_STATUS_PEDIDO:
    "loja/pedido/getStatus" /** @param {String} tiporetorno - (array | objeto) */,
  CANCELAR_PEDIDO:
    "loja/pedido/cancelar/" /** @param {String} idpedido - ID do pedido */,
  CANCELAR_PEDIDO_MKTPLACE:
    "marketplace/pedido/cancelar/" /** @param {String} idpedido_marketplace - ID do pedido marketplace */,
  VALIDATE_TICKET: "/loja/pedido_item/queimar_ingresso",

  /**
   * @description - Endpoints de OPERAÇÕES/LOGINS
   * @param {String} LISTAR_LOGINS - Endpoint para listar logins da loja
   */

  LISTAR_LOGINS: "loja/consumidor/getLoginsExternos",

  /**
   * @description - Endpoints de OPERAÇÕES/EQUIPAMENTOS
   * @param {String} LISTAR_EQUIPAMENTOS - Endpoint para listar equipamento
   * @param {String} CADASTRAR_EQUIPAMENTO - Endpoint para cadastrar equipamento
   * @param {String} ALTERAR_EQUIPAMENTO - Endpoint para alterar equipamento @param {String} idequipamento - ID do equipamento
   * @param {String} DELETAR_EQUIPAMENTO - Endpoint para deletar equipamento @param {String} idequipamento - ID do equipamento
   * @param {String} GERAR_LINK_VENDAS - Endpoint para gerar o link de vendas @param {String} idponto_venda - ID do ponto de venda @param {String} idequipamento - ID do equipamento
   * @param {String} DESABILITAR_EQUIPAMENTO - Endpoint para desabilitar equipamento @param {String} idequipamento - ID do equipamento
   * @param {String} GERAR_QRCODE - Endpoint para gerar o QRCode do link de vendas
   */

  LISTAR_EQUIPAMENTOS: "equipamento/listar",
  LISTAR_EQUIPAMENTO_DISPONIVEL:
    "equipamento/listarDisponivel/" /** @param {String} {idponto_venda | empty} - ID do ponto de venda ou empty */,
  CADASTRAR_EQUIPAMENTO: "equipamento/cadastro",
  ALTERAR_EQUIPAMENTO:
    "equipamento/alterar/" /** @param {String} idequipamento - ID do equipamento */,
  DELETAR_EQUIPAMENTO:
    "equipamento/deletar/" /** @param {String} idequipamento - ID do equipamento */,
  GERAR_LINK_VENDAS:
    "equipamento/geraLink/" /** @param {String} idponto_venda - ID do ponto de venda @param {String} idequipamento - ID do equipamento */,
  DESABILITAR_EQUIPAMENTO:
    "equipamento/desabilitar/" /** @param {String} idequipamento - ID do equipamento */,
  GERAR_QRCODE: "equipamento/link_vendas/exibir",

  /**
   * @description Endpoints de RELATÓRIOS SINTÉTICO
   * @param {String} LISTAR_RECEBIMENTOS - Endpoint para listar recebimentos da loja
   * @param {String} LISTAR_VENDA_POR_CANAL - Endpoint para listar vendas por canal da loja
   * @param {String} LISTAR_VENDA_POR_DIA - Endpoint para listar vendas por dia da loja
   * @param {String} LISTAR_VENDA_POR_FORMA_PGT - Endpoint para listar vendas por forma de pagamento da loja
   * @param {String} LISTAR_VENDA_POR_PRODUTO - Endpoint para listar vendas por produto da loja
   * @param {String} LISTAR_VENDA_POR_TIPO_PRODUTO - Endpoint para listar vendas por tipo de produto da loja
   * @param {String} LISTAR_NF_CONSUMIDOR_FINAL - Endpoint para listar nf de consumidor final
   * @param {String} LISTAR_CANCELAMENTOS_TAXAS - Endpoint para listar receitas de cancelamentos com taxas
   * @param {String} LISTAR_VENDA_POR_PDV - Endpoint para listar vendas por pdv da loja
   */

  LISTAR_RECEBIMENTOS: "relatorio/venda/recebimentos",
  LISTAR_VENDA_POR_CANAL: "relatorio/venda/canal",
  LISTAR_VENDA_POR_DIA: "relatorio/venda/dia",
  LISTAR_VENDA_POR_FORMA_PGT: "relatorio/venda/forma",
  LISTAR_VENDA_POR_PRODUTO: "relatorio/venda/produto",
  LISTAR_VENDA_POR_TIPO_PRODUTO: "relatorio/venda/tipo",
  LISTAR_NF_CONSUMIDOR_FINAL: "relatorio/pedido/nfconsumidorfinal",
  LISTAR_CANCELAMENTOS_TAXAS: "relatorio/receitas/cancelamento",
  LISTAR_VENDA_POR_PDV: "relatorio/ponto_venda/loja",

  /**
   * @description Endpoints de RELATÓRIOS ANALÍTICOS
   * @param {String} RELATORIO_ANALITICO_GERAL - Endpoint para gerar relatório analítico da loja
   * @param {String} RELATORIO_ANALITICO_OMNICHANNEL - Endpoint para gerar relatório analítico da loja
   * @param {String} RELATORIO_ANALITICO_FINANCEIRO - Endpoint para gerar relatório analítico financeiro da loja
   * @param {String} RELATORIO_ANALITICO_FINANCEIRO_OMNI - Endpoint para gerar relatório analítico financeiro Omnichannel das lojas
   * @param {String} RELATORIO_ANALITICO_CONSUMIDORES_OMNI - Endpoint para gerar relatório analítico consumidores das lojas
   * @param {String} RELATORIO_ANALITICO_VALIDACAO - Endpoint para gerar relatório analítico validação da loja
   * @param {String} LISTAR_LOJAS_REGIONAL - Endpoint para listar lojas por regional
   */

  RELATORIO_ANALITICO_GERAL: "relatorio/venda/analitico",
  RELATORIO_ANALITICO_OMNICHANNEL: "relatorio/venda/analiticoomnichannel",
  RELATORIO_ANALITICO_FINANCEIRO: "relatorio/venda/analitico/financeiro",
  RELATORIO_ANALITICO_CONSUMIDORES_OMNI: "relatorio/venda/consumidor/geral",
  RELATORIO_ANALITICO_FINANCEIRO_OMNI:
    "relatorio/venda/analitico/financeiroomnichannel",
  RELATORIO_ANALITICO_VALIDACAO: "relatorio/venda/queima_ingresso",
  LISTAR_LOJAS_REGIONAL:
    "loja/" /** @param {String} idregional - ID da regional */,

  /**
   * @description Endpoints de MARKETING
   * @param {String} GET_MKT_CONFIGS - Endpoint para listar configurações de marketing da loja
   * @param {String} CADASTRAR_CONFIGS_MARKETING - Endpoint para cadastrar configurações de marketing da loja
   * @param {String} ALTERAR_CONFIGS_MARKETING - Endpoint para alterar configurações de marketing da loja @param {String} idmarketing - ID da configuração
   * @param {String} UPLOAD_IMAGEM_MARKETING - Endpoint para upload de imagens de marketing da loja
   */

  GET_MKT_CONFIGS: "marketing/getMarketing",
  CADASTRAR_CONFIGS_MARKETING: "marketing/cadastro",
  ALTERAR_CONFIGS_MARKETING:
    "marketing/alterar/" /** @param {String} idmarketing - ID da configuração */,
  UPLOAD_IMAGEM_MARKETING: "marketing/banner/upload",

  /**
   * @description Endpoints de FINANCEIRO/REGIONAIS
   * @param {String} LISTAR_REGIONAIS - Endpoint para listar regionais
   * @param {String} CADASTRAR_REGIONAL - Endpoint para cadastrar regional
   * @param {String} ALTERAR_REGIONAL - Endpoint para alterar regional @param {String} idregional - ID da regional
   * @param {String} DELETAR_REGIONAL - Endpoint para deletar regional @param {String} idregional - ID da regional
   */

  LISTAR_REGIONAIS: "financeiro/regionais/listar",
  CADASTRAR_REGIONAL: "financeiro/regionais/cadastro",
  ALTERAR_REGIONAL:
    "financeiro/regionais/alterar/" /** @param {String} idregional - ID da regional */,
  DELETAR_REGIONAL:
    "financeiro/regionais/deletar/" /** @param {String} idregional - ID da regional */,

  /**
   * @description Endpoints de FINANCEIRO/FORMAS DE PAGAMENTO
   * @param {String} LISTAR_FORMAS_DE_PAGAMENTO- Endpoint para listar formas de pagamento
   * @param {String} CADASTRAR_FORMAS_DE_PAGAMENTO - Endpoint para cadastrar forma de pagamento
   * @param {String} ALTERAR_FORMAS_DE_PAGAMENTO - Endpoint para alterar forma de pagamento @param {String} idforma_pag - ID da forma de pagamento
   * @param {String} DELETAR_FORMAS_DE_PAGAMENTO - Endpoint para deletar forma de pagamento @param {String} idforma_pag - ID da forma de pagamento
   */

  LISTAR_FORMAS_DE_PAGAMENTO: "forma_pagamento/listar",
  CADASTRAR_FORMAS_DE_PAGAMENTO: "forma_pagamento/cadastro",
  ALTERAR_FORMAS_DE_PAGAMENTO:
    "forma_pagamento/alterar/" /** @param {String} idforma_pag - ID da forma de pagamento */,
  DELETAR_FORMAS_DE_PAGAMENTO:
    "forma_pagamento/deletar/" /** @param {String} idforma_pag - ID da forma de pagamento */,

  /**
   * @description Endpoints de TERMOS
   * @param {String} LISTAR_TERMOS - Endpoint para listar os termos cadastrados
   * @param {String} CADASTRAR_TERMOS - Endpoint para cadastrar termos
   * @param {String} ALTERAR_TERMOS - Endpoint para alterar termos @param {String} idtermo - ID do termo
   * @param {String} DELETAR_TERMOS - Endpoint para deletar termos @param {String} idtermo - ID do termo
   */

  LISTAR_TERMOS: "termo/listar",
  CADASTRAR_TERMOS: "termo/cadastro",
  ALTERAR_TERMOS: "termo/alterar/" /** @param {String} idtermo - ID do termo */,
  DELETAR_TERMOS: "termo/deletar/" /** @param {String} idtermo - ID do termo */,

  /**
   * @description Endpoints de CONFIGURAÇÂO DO OMNICHANNEL
   * @param {String} LISTAR_CONFIG_OMNI - Endpoint para listar as configurações do omnichannel
   * @param {String} LISTAR_TEMPLATES_ODT - Endpoint para listar os templates de ODT
   * @param {String} ALTERAR_CONFIG_OMNI - Endpoint para alterar as configurações do omnichannel
   */

  LISTAR_CONFIG_OMNI: "config/getConfig",
  LISTAR_TEMPLATES_ODT: "config/getIdsOdtValidos",
  ALTERAR_CONFIG_OMNI: "config/alterar",
  /**
   * @description Endpoints de CONFIGURAÇÂO DO MARKETPLACE
   * @param {String} LISTAR_CONFIG_MARKET - Endpoint para listar as configurações do MARKETPLACE
   * @param {String} ALTERAR_CONFIG_MARKET - Endpoint para alterar as configurações do MARKETPLACE
   */

  LISTAR_CONFIG_MARKET: "marketplace/config/getConfig",
  ALTERAR_CONFIG_MARKET: "marketplace/config/alterar",

  /**
   * @description Endpoints de CONSUMIDORES DO MARKETPLACE
   * @param {String} LISTAR_CONSUMIDORES_MARKET - Endpoint para listar os consumidores do MARKETPLACE
   * @param {String} LISTAR_PEDIDOS_MARKET - Endpoint para listar os consumidores do MARKETPLACE
   * @param {String} ALTERAR_CONSUMIDORES_MARKET - Endpoint para alterar os consumidores do MARKETPLACE
   * @param {String} CADASTRAR_CONSUMIDORES_MARKET - Endpoint para cadastrar os consumidores do MARKETPLACE
   * @param {String} DESABILITAR_CONSUMIDORES_MARKET - Endpoint para desabilitar os consumidores do MARKETPLACE
   * @param {String} LISTAR_ITENS_PEDIDO_MARKET - Endpoint para listar itens dos consumidores do MARKETPLACE
   */
  LISTAR_CONSUMIDORES_MARKET: "/consumidor/listar",
  ALTERAR_CONSUMIDORES_MARKET:
    "/consumidor/alterar/" /** @param {String} idusuario - ID do usuario */,
  CADASTRAR_CONSUMIDORES_MARKET: "/consumidor/cadastro",
  DESABILITAR_CONSUMIDORES_MARKET:
    "/consumidor/desabilitar/" /** @param {String} id - ID do usuario */,
  LISTAR_PEDIDOS_MARKET: "/marketplace/pedido/consumidor/listar",
  LISTAR_ITENS_PEDIDO_MARKET:
    "/vendas/marketplace/itens/" /** @param {String} ano_mes */ /** @param {String} idpedido_marketplace */,

  /**
   * @description Endpoints de PACOTES DE INGRESSO
   * @param {String} LISTAR_PACOTES - Endpoint para listar os Pacotes de ingressos
   * @param {String} LISTAR_ITENS_PACOTE - Endpoint para listar os itens dos Pacotes de ingressos
   * @param {String} CADASTRAR_PACOTE - Endpoint para cadastrar os Pacotes de ingressos
   * @param {String} DELETAR_PACOTE - Endpoint para deletar os Pacotes de ingressos
   * @param {String} DELETAR_ITEM_PACOTE - Endpoint para deletar item do Pacote de ingressos
   * @param {String} CADASTRAR_PORTADOR - Endpoint para cadastrar o partador no ingresso
   * @param {String} CADASTRAR_PORTADORES - Endpoint para cadastrar os portadores no pacote de ingressos
   * @param {String} SEND_ALL_TICKETS - Endpoint para enviar o pacote de ingressos para o comprador ou todos os portadores
   * @param {String} SEND_UNIQUE_TICKET_TO_EMAIL - Endpoint para enviar o item do pacote para o portador do item por email
   * @param {String} SEND_UNIQUE_TICKET_TO_SMS - Endpoint para enviar o item do pacote para o portador do item por sms
   * @param {String} SEND_UNIQUE_TICKET_TO_WHATSAPP - Endpoint para enviar o item do pacote para o portador do item por whatsapp
   * @param {String} PACKAGE_EMIT_REPORT - Endpoint para listar o relatório de emissão de pacotes
   */

  LISTAR_PACOTES: "pacotes",
  LISTAR_ITENS_PACOTE: "loja/pedido/consumidor/listar",
  CADASTRAR_PACOTE: "pacote",
  DELETAR_PACOTE: "pacote/",
  DELETAR_ITEM_PACOTE: "loja/pedido_item/remover",
  CADASTRAR_PORTADOR: "loja/pedido_item/portador/",
  CADASTRAR_PORTADORES: "loja/pedido/portador",
  SEND_ALL_TICKETS: "loja/pedido/envio/pacote",
  SEND_UNIQUE_TICKET_TO_EMAIL:
    "loja/pedido_item/email/" /** @param {String} iditem - ID do item do pacote a ser enviado */,
  SEND_UNIQUE_TICKET_TO_SMS:
    "loja/pedido_item/sms/" /** @param {String} iditem - ID do item do pacote a ser enviado */,
  SEND_UNIQUE_TICKET_TO_WHATSAPP:
    "loja/pedido_item/whatsapp/" /** @param {String} iditem - ID do item do pacote a ser enviado */,
  PACKAGE_EMIT_REPORT: "relatorio/venda/taxas",
  CANCELAR_MIDIA:
    "loja/pedido_item/cancelar/" /** @param {String} idpedido - ID da midia */,

  /**
   * @description Endpoints de CIRCUS
   * @param {String} SINCRONIZAR_CIRCUS - Endpoint para sincronizar o circus
   * @param {String} SINCRONIZAR_CIRCUS_ALL - Endpoint para sincronizar o circus
   */

  SINCRONIZAR_CIRCUS: "loja/sincronizar/circus",
  SINCRONIZAR_CIRCUS_ALL: "loja/sincronizar/circus/all",

  /**
   * @description Endpoints de CHECK-IN
   * @param {String} FLUXO_CHECKIN - Endpoint para trazer o fluxo do CHECK-IN
   * @param {String} LISTAR_CHECKIN - Endpoint para listar os CHECK-INs
   * @param {String} DESFAZER_QUEIMA_INGRESSO - Endpoint para desfazer queima de ingresso
   * @param {String} EXPORTAR_CHECKIN - Endpoint para exportar dados de CHECK-IN
   */

  FLUXO_CHECKIN: "/checkin/fluxo_checkin",
  LISTAR_CHECKIN: "/checkin/listar",
  DESFAZER_QUEIMA_INGRESSO: "/loja/pedido_item/desfazer_queimar_ingresso",
  EXPORTAR_CHECKIN: "/checkin/exportar",
};
